import SkillGroup from './skill-group.entity';

export default class PersistSkill {
  whatPTBR: string;

  whatES: string;

  whatEN: string;

  type: string;

  group: SkillGroup

  constructor(obj: any = {}) {
    this.whatPTBR = obj.whatPTBR || '';
    this.whatES = obj.whatES || '';
    this.whatEN = obj.whatEN || '';
    this.type = obj.type || '';
    this.group = obj.group || { id: '', name: '' };
  }


  get groupId() {
    return this.group.id;
  }
}
